import { cssFluidSize } from "theme/styleHelpers"
import { MuiComponentOverrides } from "."

export const MuiButtonOverrides: MuiComponentOverrides<'MuiButton', 'MuiButton'> = {
    defaultProps: {
      variant: 'contained',
      size: 'medium',
      disableElevation: true
    },
    styleOverrides: {
      root: {
        fontWeight: 700,
        // paddingBottom: 22,
        // paddingLeft: 28,
        // paddingRight: 28,
      },
      sizeLarge: {
        paddingY: 15,
        paddingX: 22,
        fontSize: cssFluidSize([16, 18]),
      },
      sizeSmall: {
        paddingY: 7,
        paddingX: 15,
        fontSize: cssFluidSize([14, 16]),
        // paddingTop: 16,
        // paddingBottom: 16,
      },
      text: {
        // padding: 0,
        backgroundColor: 'transparent',
        ":hover": {
          backgroundColor: 'transparent',
        }
      }
    }
}
